import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';
import { Typo } from 'uikit/content';
import { getSanitizedDescription } from '@/exceed';

import DefaultCoverArt from '../images/default-video-shortcut-cover-art.svg';

import styles from '../styles/videosAdminInfo.module.scss';

const VideosAdminInfo = ({ videoCompose: { data, isFetching } = {} }) => {
  const { type } = useParams();

  if (isFetching) return <Loading className={styles.loader} />;

  const { cover_art: coverArt } = data;
  const { id, organization_id: orgId } = data.original_content_list_item || {};
  const route = `/videos/organizations/${orgId}/${type}/${id}/compose`;

  return (
    <div className={styles.element}>
      <div className={styles.imageContainer}>
        {!coverArt ? (
          <DefaultCoverArt />
        ) : (
          <img alt="" className={styles.image} src={coverArt.url} />
        )}
      </div>
      <div className={styles.textContainer}>
        <div className={classnames(styles.textContainer, styles.hasSmallGap)}>
          <Typo className={styles.title} element="h3" variant="d01">
            {data.name}
          </Typo>
          <Typo
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: getSanitizedDescription({ html: data.description }),
            }}
            element="div"
            variant="b01"
          />
        </div>
        <Button color="brand" size="small" text={i18n.t('view-original')} to={route} />
      </div>
    </div>
  );
};

VideosAdminInfo.propTypes = {
  videoCompose: PropTypes.shape({}),
};

export default VideosAdminInfo;
